export const CONNECTED_EMAIL_DATA_ACCESS = 'connected-email-data-access';
export const FIELD_LEVEL_PERMISSIONS_ACCESS = 'field-level-permissions-access';
export const AGENT_PRESENCE = 'inbox-agent-presence';
export const CONVERSATIONS_HOSTED_EMAIL_ACCESS = 'conversations-hosted-email-access';
export const MESSAGING_TRUSTED = 'messaging-trusted';
export const HELP_DESK_ACCESS = 'help-desk-access';
export const HELP_DESK_ROUTING_CONFIG_EDIT = 'help-desk-routing-config-edit';
export const HELP_DESK_PORTAL_ACCESS = 'help-desk-portal-access';